<template>
    <b-row>
        <b-col>
            <div @click.stop="selecionar(4)">
                <app-box
                    class="icon-button"
                    icone="fa-calendar"
                    titulo="ETAPAS APROVADAS E NÃO FATURADAS ATÉ 30 DIAS"
                    corBox="success"
                    corTexto="success"
                    :selecionado="selecionado === 4"
                    >{{ pnlVencimentos.quantidade30Dias }}</app-box
                >
            </div>
        </b-col>
        <b-col>
            <div @click.stop="selecionar(3)">
                <app-box
                    class="icon-button"
                    icone="fa-calendar"
                    titulo="ETAPAS APROVADAS E NÃO FATURADAS 31 E 45 DIAS"
                    corBox="warning"
                    corTexto="warning"
                    :selecionado="selecionado === 3"
                    >{{ pnlVencimentos.quantidade31a45 }}</app-box
                >
            </div>
        </b-col>
        <b-col>
            <div @click.stop="selecionar(2)">
                <app-box
                    class="icon-button"
                    icone="fa-calendar"
                    titulo="ETAPAS APROVADAS E NÃO FATURADAS 46 E 60 DIAS"
                    corBox="danger"
                    corTexto="danger"
                    :selecionado="selecionado === 2"
                    @click="selecionar(2)"
                    >{{ pnlVencimentos.quantidade46a60 }}</app-box
                >
            </div>
        </b-col>
        <b-col>
            <div @click.stop="selecionar(1)">
                <app-box
                    class="icon-button"
                    icone="fa-calendar"
                    titulo="ETAPAS APROVADAS E NÃO FATURADAS ACIMA DE 61 DIAS"
                    corBox="secondary"
                    corTexto="secondary"
                    :selecionado="selecionado === 1"
                    @click="selecionar(1)"
                    >{{ pnlVencimentos.quantidade61Acima }}</app-box
                >
            </div>
        </b-col>
        
        <b-col cols="12" class="text-center mt-3" v-if="selecionado > 0">
            <b-button 
                variant="outline-secondary" 
                size="sm"
                @click="limparFiltro"
                title="Limpar filtro e mostrar todas as etapas"
            >
                <i class="fa fa-times"></i> Limpar Filtro
            </b-button>
        </b-col>
        
                <b-col sm="12">
                    <b-alert variant="warning" show class="mt-4">
                        <strong>Observação:</strong><br>
                        A CONTRATADA deve apresentar a nota fiscal em até 60 dias após a aprovação do gestor. Em caso de
                        atraso, será aplicada uma multa diária de 0,33%, limitada a 10% do valor do contrato. Reincidências
                        podem resultar na rescisão do contrato e outras penalidades. Para serviços aprovados a partir de 1º de
                        outubro, o prazo para apresentação das notas fiscais é até o 5º dia útil do mês de dezembro do ano
                        corrente.
                    </b-alert>
                </b-col>
            
    </b-row>
    
</template>

<script>
export default {
    props: {
        pnlVencimentos: {
            type: Object
        },
        etapasPorPeriodo: {
            type: Object,
            default: () => ({
                dias30: [],
                dias31a45: [],
                dias46a60: [],
                diasAcima61: []
            })
        }
    },

    data() {
        return {
            selecionado: 0
        }
    },

    methods: {
        selecionar(periodo) {
            if (this.selecionado === 0 || this.selecionado != periodo) {
                this.selecionado = periodo
            } else {
                this.selecionado = 0
            }
            
            let etapasIds = []
            if (this.selecionado > 0) {
                switch (this.selecionado) {
                    case 4: 
                        etapasIds = this.etapasPorPeriodo.dias30 || []
                        break
                    case 3: 
                        etapasIds = this.etapasPorPeriodo.dias31a45 || []
                        break
                    case 2: 
                        etapasIds = this.etapasPorPeriodo.dias46a60 || []
                        break
                    case 1: 
                        etapasIds = this.etapasPorPeriodo.diasAcima61 || []
                        break
                }
            }
            
            this.$emit('filtrar', {
                periodo: this.selecionado,
                etapasIds: etapasIds
            })
        },

        limparFiltro() {
            this.selecionado = 0
            this.$emit('filtrar', {
                periodo: 0,
                etapasIds: []
            })
        }
    }
}
</script>
